// Imports
import React, { Fragment } from 'react';
import { useSelector } from "react-redux";
import { Routes, Route, Navigate } from 'react-router-dom';

// Views
import DashboardMainView from "Modules/dashboard/views/main"
import { HasPermission } from "Core/security";


// router 
const routerDashboard = (props) => {
	const { match } = props
	const user = useSelector(state => state.securityRedux.user)
	return (
		<Routes>
			{
				HasPermission(user, "db", [63]) &&
				<Fragment>
					<Route path='/' element={<Navigate to="/app/dashboard/main" />}></Route>
					<Route path='main' element={<DashboardMainView />} />
				</Fragment>
			}
			<Route path="*" element={<Navigate to="/app/error" />} />
		</Routes>
	);
};

export default routerDashboard